// @flow

export const DELIVERY_CHANNEL_EMAIL = 'Email';
export const DELIVERY_CHANNEL_E_INVOICE = 'E-invoice';
export const PERIOD_MONTHLY = 1;
export const PERIOD_QUARTERLY = 3;
export const PERIOD_YEARLY = 12;
export const FREEMIUM_SELF_SERVICE_QUERY = 'fss';
export const FREEMIUM_SELF_SERVICE_HEADER = 'self purchase modal';
